export const SET_CONTENT = "MODAL/SET_CONTENT";
export const SET_VISIBLE = "MODAL/SET_VISIBLE";
